import { LuX } from "react-icons/lu";

export function AttachedImageIcon({
  attachedImg,
  onRemove,
}: {
  attachedImg: File;
  onRemove: () => void;
}) {
  return (
    <div className="relative inline-block">
      <img
        src={URL.createObjectURL(attachedImg)}
        alt="Attached"
        className="w-16 h-16 rounded-lg object-cover bg-dark-surface-tertiary"
      />
      <button
        onClick={onRemove}
        className="absolute -top-1.5 -right-1.5 bg-dark-surface-secondary hover:bg-dark-hover
          border border-dark-border rounded-full p-1 transition-colors"
      >
        <LuX className="w-3 h-3 text-dark-text-secondary" />
      </button>
    </div>
  );
}
